import { motion } from 'framer-motion';

export default function ValuesSection(){
     const values = [
    {
      title: 'Authenticity',
      description: 'We stay true to traditional practices while making them accessible for modern life.',
      icon: '🙏'
    },
    {
      title: 'Inclusivity',
      description: 'Everyone is welcome here, regardless of experience level, body type, or background.',
      icon: '🤝'
    },
    {
      title: 'Mindfulness',
      description: 'We cultivate present-moment awareness in everything we do and teach.',
      icon: '🧘'
    },
    {
      title: 'Growth',
      description: 'We believe in continuous learning and personal development for all.',
      icon: '🌱'
    }
  ];

    return(
        <div className="bg-white pt-4 sm:pt-6 pb-12 sm:pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8 sm:mb-10"
          >
            <p className="text-xs sm:text-sm font-semibold tracking-[0.28em] uppercase text-[#1C8F86] mb-4">
              Our Values
            </p>
            <h2 className="text-4xl sm:text-5xl font-semibold text-[#15302B] mb-6">Built on care, clarity, and trust</h2>
            <p className="text-lg sm:text-xl text-[#4D625D] max-w-3xl mx-auto leading-8">
              These core principles guide everything we do and shape the welcoming, transformative experience we create for our community.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
            {values.map((value, index) => (
              <motion.div 
                key={index} 
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: index * 0.1 + 0.2 }}
                className="group rounded-2xl border border-[#E0D4B8]/60 bg-white/50 p-5 shadow-[0_4px_20px_rgb(0,0,0,0.03)] backdrop-blur-sm transition-all duration-300 hover:shadow-[0_4px_20px_rgba(28,143,134,0.1)] hover:-translate-y-1 hover:bg-white/70"
              >
                <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#D3F7F1]/80 text-lg transition-transform group-hover:scale-110">
                  {value.icon}
                </div>
                  <h3 className="text-lg font-semibold text-[#15302B] mb-1.5">{value.title}</h3>
                  <p className="text-[13px] text-[#4D625D] leading-relaxed">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

    )
}
